// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"4f7b3521","377":"baf9e066"}[chunkId] + ".chunk.css";
};